import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sitekey: String,
    theme: { type: String, default: "light" }
  }

  connect() {
    this.widgetId = null
    this.renderWidget()
  }

  disconnect() {
    this.clearTurnstilePoll()

    if (this.widgetId == null || typeof turnstile === "undefined") return

    turnstile.remove(this.widgetId)
    this.widgetId = null
  }

  renderWidget() {
    if (typeof turnstile === "undefined") {
      this.waitForTurnstile()
      return
    }

    this.mountWidget()
  }

  waitForTurnstile() {
    this.clearTurnstilePoll()

    this.turnstilePoll = window.setInterval(() => {
      if (typeof turnstile === "undefined") return

      this.clearTurnstilePoll()
      this.mountWidget()
    }, 50)
  }

  mountWidget() {
    if (!this.element.isConnected || this.widgetId != null) return

    this.widgetId = turnstile.render(this.element, {
      sitekey: this.sitekeyValue,
      theme: this.themeValue
    })
  }

  clearTurnstilePoll() {
    if (!this.turnstilePoll) return

    window.clearInterval(this.turnstilePoll)
    this.turnstilePoll = null
  }
}
